var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "#003B6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 7H9.0625C7.92383 7 7 7.92383 7 9.0625V15.9375C7 17.0762 7.92383 18 9.0625 18H12.8724V13.7389H11.4401V12.0775H12.8724V10.8529C12.8724 9.4349 13.7461 8.66146 15.0137 8.66146C15.6152 8.66146 16.138 8.70443 16.2884 8.72591V10.2083L15.4147 10.2155C14.7201 10.2155 14.5911 10.5378 14.5911 11.0176V12.0775H16.2311L16.0163 13.7389H14.5911V18H15.9375C17.0762 18 18 17.0762 18 15.9375V9.0625C18 7.92383 17.0762 7 15.9375 7Z",
    fill: "#003B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.473fc38d4ce023a41a31e7a5bf190dd9.svg";
export { ForwardRef as ReactComponent };